<template>
  <div>
        <!--拒绝弹窗-->
        <el-dialog 
        :visible.sync="refuseShow" 
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :z-index="5"
        top="30vh" 
        >
            <div class="refuse mb-3">
                <div class="room-title mt-2">
                    接不了酒店
                </div>
                <el-select v-model="formData.store_id" placeholder="请选择" class="select" @change="betterOfferHotel(formData.store_id)">
                    <el-option
                    v-for="item in match_hotel_list"
                    :key="item.offer_store_id"
                    :label="item.hotel_title"
                    :value="item.offer_store_id"
                    >
                        <span style="float: left">{{ item.hotel_title }}</span>
                        <span :class="item.whetherQuote?'text-success':'text-danger'" style="float: right;  font-size: 12px">{{ item.whetherQuote?'已报价':'未报价' }}</span>
                    </el-option>
                </el-select>
            </div>
            <!--报价说明-->
            <div class="refuse mt-3 refuse-type">
                <div class="room-title">
                    接不了原因  
                </div>
                <div class="w-75">  
                    <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入接不了原因"
                        resize="none"
                        class="w-100"
                        v-model="formData.offer_remark">
                    </el-input>
                    <!--快捷填写-->
                    <ul class="radio-list">
                        <li :class="{'active':item.name==formData.offer_remark}" v-for="item in radioName" :key="item.id" @click="formData.offer_remark=item.name">{{ item.name }}</li>
                    </ul>
                </div>
            </div>
            <div class="refuse-bottom-btn">
                <el-button   size="small" @click="$emit('onShow')">返回</el-button>
                <el-button  @click="submitForm" type="primary" size="small">确认填写</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions,mapMutations } from 'vuex'
export default {
  name: 'OrderHoteRefuse',
  components: {},
  props: {
    refuseShow: {
      type: Boolean,
      default: false
    },
    match_hotel_list: {
      type: Array,
      default: () => []
    },
    match_store_id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
        formData:{
            oid:'',                         //订单ID
            store_id:'',                    //报价酒店ID
            offer_remark:'',                //接不了备注
        },
        radioName:[
            {id:1,name:'满房'},
            {id:2,name:'房间不足'},
            {id:3,name:'当天无房,其他日期有房'},
            {id:4,name:'已离职'},
            {id:5,name:'已换酒店'}
        ]
    };
  },
  computed: {},
  watch: {
        match_store_id: {
            handler(newVal) {
                this.formData.store_id=Number(newVal);
            },
            immediate: true 
        }
  },
  created() {},
  mounted() {},
  methods: {
         ...mapActions(['replyRefuse']),
        //切换报价酒店
        betterOfferHotel(id){
            let offer_store_id=id?id:this.formData.store_id;
            let match_hotel_list=this.match_hotel_list;
            let match_hotel=match_hotel_list.find(item=>item.offer_store_id==offer_store_id); //或者选中的酒店报价组
            let value=this.$_Object.mergeByFirstKey(this.formData,match_hotel);       // 俩个对象合并只合并第一个存在的key
            value={
                ...value,
            };
            this.formData=value;
        },
        //提交接不了原因
        submitForm(){
            this.replyRefuse({data:this.formData,successFun:()=>{
                    this.$message.success('报价成功');
                    this.$emit('getorderDetail');
                }
            })
        },
  }
};
</script>

<style lang="scss" scoped>
    .order-hotel-fill-title{
        font-size: 20px;
        font-weight: bold;
        color: #333;
        text-align: center;
        margin-bottom: 20px;
    }
    .refuse{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px #eee solid;
        padding-bottom: 16px;
    }
    .room-title{
        font-size: 16px;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-left: 12px;
        &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 2px;
            height: 20px;
            width: 4px;
            background-color: var(--smtc-color-primary);
            border-radius: 50px;
        }
    }
    .refuse-bottom-btn{
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
    .refuse-hint{
        font-size: 12px;
        width: 100%;
        color: red;
        display: block;
        margin-top: 12px;
    }
    .refuse-value{
        display: flex;
        flex-direction: column;
    }
    .radio-list{
        display: flex;
        margin-top: 12px;
        justify-content: space-between;
        li{
            border: 1px #DCDFE6 solid;
            padding: 4px 10px;
            margin-right: 6px;
            font-size: 12px;
            border-radius: 4px;
            cursor: pointer;
        }
        .active{
            color: #Fff;
            background-color: var(--smtc-color-primary);
            border: 1px var(--smtc-color-primary) solid;
        }
    }
</style>
<style>
    .refuse  .el-input__inner{
        font-size: 12px;

    }
    .refuse-type .el-input__inner{
        line-height: 31px;
        height: 31px;
    }
    .refuse-type .el-input__icon{
        line-height: 31px;
    }
    .refuse .select .el-input__inner{
        min-width: 421px;
    }
    .refuse .el-textarea__inner{
        font-size: 14px;
        font-family: '微软雅黑';
    }
</style>